import React from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import { createQueryClient } from '@/lib/query'
import { router } from './app/router'
import './styles/globals.css'
import { Toaster } from 'sonner'
import { ThemeProvider } from './app/theme'

const rootEl = document.getElementById('root')!
const root = createRoot(rootEl)

const queryClient = createQueryClient()

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <RouterProvider router={router} />
        <Toaster richColors position="top-right" />
      </ThemeProvider>
    </QueryClientProvider>
  </React.StrictMode>,
)
